var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tbody",
    {
      staticClass: "directory-order-table-row",
      class: [_vm.index % 2 === 0 ? "row-even" : "row-odd"],
    },
    [
      _vm.showVirtualScrollPlaceholder
        ? [
            _c("tr", { staticClass: "virtual-scroll-placeholder" }, [
              _c("td", { attrs: { colspan: "12" } }, [
                _c(
                  "div",
                  {
                    style: {
                      display: "inline-block",
                      minHeight: _vm.placeHolderMinHeight + "px",
                      verticalAlign: "middle",
                    },
                  },
                  [_vm._v(" ")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "font-dark-gray" }, [
                  _vm._v(_vm._s(_vm.$t("loading")) + "..."),
                ]),
              ]),
            ]),
          ]
        : [
            _vm._l(_vm.displayItems, function (item, dIndex) {
              return [
                _vm._l(item.companies, function (company, mainCompanyIndex) {
                  return [
                    _c(
                      "tr",
                      { key: company.id, staticClass: "directory-row" },
                      [
                        _c("td", { staticClass: "tenancyId" }, [
                          _vm.allowClickTenancyId
                            ? _c(
                                "a",
                                {
                                  staticClass: "name-hyper-link",
                                  on: { click: _vm.clickTenancyId },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      mainCompanyIndex ? "" : item.tenancy.id
                                    )
                                  ),
                                ]
                              )
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    mainCompanyIndex ? "" : item.tenancy.id
                                  )
                                ),
                              ]),
                        ]),
                        _vm._v(" "),
                        _vm.isFloor
                          ? _c("td", { staticClass: "premises" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("isEmptyValue")(company["premises"])
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", { staticClass: "engName" }, [
                          _vm.allowClickCompanyName
                            ? _c(
                                "a",
                                {
                                  staticClass: "name-hyper-link",
                                  on: { click: _vm.clickCompanyName },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("isEmptyValue")(company.engName)
                                    ) + "\n            "
                                  ),
                                ]
                              )
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("isEmptyValue")(company.engName)
                                  )
                                ),
                              ]),
                          _vm._v(" "),
                          !company.chsName &&
                          company.chtName &&
                          _vm.viewType === "LOBBY"
                            ? _c("span", { staticClass: "no-cht-name" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("directory.hint.chinese"))
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "chtName" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm._f("isEmptyValue")(company.chtName)) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "floor" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.isFloor
                                  ? item.floor || _vm.$t("emptyValue")
                                  : _vm.getFloorAndPremisesAtTerminal(company)
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "effectiveDate" }, [
                          _vm._v(
                            _vm._s(
                              mainCompanyIndex
                                ? ""
                                : _vm.formatEffectiveDate(_vm.directory)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        !_vm.isFloor
                          ? _c(
                              "td",
                              { staticClass: "screen" },
                              [
                                _c("HKLSelect", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.allowChangeScreen && dIndex == 0,
                                      expression:
                                        "allowChangeScreen && dIndex == 0",
                                    },
                                  ],
                                  staticClass: "hkl-select--smallsize",
                                  attrs: {
                                    disabled:
                                      !_vm.allowChangeScreen || dIndex !== 0,
                                    value: item.screen,
                                    options: _vm.screenList,
                                    showSearch: false,
                                    placeholder: "",
                                  },
                                  on: { change: _vm.changeScreen },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "display" },
                          [
                            _c("HKLSelect", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.allowChangeColumn && dIndex == 0,
                                  expression:
                                    "allowChangeColumn && dIndex == 0",
                                },
                              ],
                              staticClass: "hkl-select--smallsize",
                              attrs: {
                                disabled:
                                  !_vm.allowChangeColumn || dIndex !== 0,
                                value: item.position,
                                options: _vm.displayList,
                                showSearch: false,
                                placeholder: "",
                              },
                              on: { change: _vm.changeColumn },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "onHold" }, [
                          _vm.allowUpdateOnHold && dIndex === 0
                            ? _c("input", {
                                directives: [
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: { checked: item.onHold },
                                on: {
                                  change: function (event) {
                                    return _vm.updateOnHold(
                                      event.target.checked
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !mainCompanyIndex,
                                expression: "!mainCompanyIndex",
                              },
                            ],
                            staticClass: "status",
                            class:
                              "status--" + _vm.getStatusClass(_vm.directory),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatStatus(item.status, item.action)
                                )
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "order" },
                          [
                            !mainCompanyIndex &&
                            _vm.allowChangeOrder &&
                            dIndex === 0
                              ? _c("HKLSelect", {
                                  staticClass:
                                    "hkl-select--smallsize hkl-select--order",
                                  attrs: {
                                    value: item.order,
                                    options: _vm.orderSelectOptions,
                                    showSearch: true,
                                    placeholder: "",
                                  },
                                  on: { change: _vm.changeOrder },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "action" }, [
                          !mainCompanyIndex &&
                          _vm.allowChangeOrder &&
                          dIndex === 0
                            ? _c("div", { staticClass: "directory-actions" }, [
                                _vm.allowMoveUp
                                  ? _c("i", {
                                      staticClass: "arrow-up",
                                      on: { click: _vm.moveUp },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.allowMoveDown
                                  ? _c("i", {
                                      staticClass: "arrow-down",
                                      on: { click: _vm.moveDown },
                                    })
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "action" },
                          [
                            _vm.showDotDropDown &&
                            _vm.dotOptions.length &&
                            !mainCompanyIndex &&
                            dIndex === 0
                              ? _c(
                                  "dotted-dropdown",
                                  {
                                    attrs: { id: "dottedDropdown-" + item.id },
                                  },
                                  [
                                    _c(
                                      "li",
                                      _vm._l(
                                        _vm.dotOptions,
                                        function (action, index) {
                                          return _c(
                                            "a",
                                            {
                                              key: index,
                                              staticClass: "dot-option-btn",
                                              on: { click: action.method },
                                            },
                                            [_vm._v(_vm._s(action.name))]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(company.subCompanies, function (subComp) {
                      return [
                        _c(
                          "tr",
                          {
                            key: subComp.id,
                            staticClass: "sub-company directory-row",
                          },
                          [
                            _c("td", { staticClass: "tenancyId" }),
                            _vm._v(" "),
                            _vm.isFloor
                              ? _c("td", { staticClass: "premises" }, [
                                  _vm._v(_vm._s(subComp["premises"])),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.subDetailHeaders, function (header) {
                              return _c(
                                "td",
                                { key: header, class: header.cls },
                                [
                                  _vm._v(
                                    _vm._s(
                                      typeof header.attr === "function"
                                        ? header.attr(subComp)
                                        : subComp[header.attr] ||
                                            _vm.$i18n.t("emptyValue")
                                    ) + "\n              "
                                  ),
                                  !subComp.chsName &&
                                  header.attr === "engName" &&
                                  subComp.chtName &&
                                  _vm.viewType === "LOBBY"
                                    ? _c(
                                        "span",
                                        { staticClass: "no-cht-name" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("directory.hint.chinese")
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c("td", { attrs: { colspan: "8" } }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._l(subComp.subDetails, function (detail) {
                          return _c(
                            "tr",
                            {
                              key: detail.id,
                              staticClass: "sub-detail directory-row",
                            },
                            [
                              _c("td", { staticClass: "tenancyId" }),
                              _vm._v(" "),
                              _vm.isFloor
                                ? _c("td", { staticClass: "premises" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.subDetailHeaders, function (header) {
                                return _c(
                                  "td",
                                  { key: header, class: header.cls },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        typeof header.attr === "function"
                                          ? header.attr(detail)
                                          : detail[header.attr] ||
                                              _vm.$i18n.t("emptyValue")
                                      ) + "\n            "
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c("td", { attrs: { colspan: "8" } }),
                            ],
                            2
                          )
                        }),
                      ]
                    }),
                  ]
                }),
              ]
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }